import { render } from "./Controls.vue?vue&type=template&id=3565e122&scoped=true&ts=true"
import script from "./Controls.vue?vue&type=script&lang=ts"
export * from "./Controls.vue?vue&type=script&lang=ts"

import "./Controls.vue?vue&type=style&index=0&id=3565e122&lang=scss&scoped=true"

import exportComponent from "/var/www/html/drupal/modules/custom/nvschade_calculator/assets/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3565e122"]])

export default __exports__